<template>
  <mp-modal :is-open="isOpen" :on-close="close" :close-on-overlay-click="!isLoading" :size="size">
    <mp-modal-content ref="content">
      <mp-modal-header>{{ title }}</mp-modal-header>
      <mp-modal-close-button :is-disabled="isDisabled" data-qa="modal-confirmation-close" @click="close" />
      <mp-modal-body>
        <slot name="content">
          <mp-text>
            {{ content }}
          </mp-text>
        </slot>
      </mp-modal-body>
      <mp-modal-footer>
        <slot name="footer" :close="close">
          <mp-button
            :variant="btnCancelStyle.variant"
            :variant-color="btnCancelStyle.color"
            :is-disabled="isLoading || isDisabled"
            data-qa="modal-confirmation-cancel"
            @click="cancel($event)"
          >
            {{ buttonCancelText }}
          </mp-button>
          <mp-button
            v-if="!cancelOnly"
            :variant-color="buttonClass"
            :is-disabled="isLoading || isDisabled"
            :is-loading="isLoading"
            ml="3"
            data-qa="modal-confirmation-submit"
            @click="confirm($event)"
          >
            {{ buttonText }}
          </mp-button>
        </slot>
      </mp-modal-footer>
    </mp-modal-content>
    <mp-modal-overlay />
  </mp-modal>
</template>
<script>
export default {
  name: 'ModalConfirmation',
  props: {
    isOpen: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
      default: 'md',
      validator(prop) {
        return ['sm', 'md', 'lg', 'xl', '2xl', 'full'].indexOf(prop) !== -1;
      },
    },
    title: {
      type: String,
      default: 'Delete',
    },
    content: {
      type: String,
      default: '',
    },
    buttonClass: {
      type: String,
      default: 'red',
    },
    buttonText: {
      type: String,
      default: 'Delete',
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
    cancelOnly: {
      type: Boolean,
      default: false,
    },
    buttonCancelClass: {
      type: String,
      default: 'ghost',
    },
    buttonCancelText: {
      type: String,
      default: 'Cancel',
    },
  },
  computed: {
    btnCancelStyle() {
      const type = {
        color: 'gray',
        variant: 'ghost',
      };

      if (this.buttonCancelClass === 'btn-primary') {
        type.color = 'blue';
        type.variant = 'solid';
      }

      return type;
    },
  },
  methods: {
    close() {
      if (!this.isLoading) this.$emit('update:is-open', false);
    },
    cancel(e) {
      this.$emit('cancel', e);
      this.close();
    },
    confirm(e) {
      this.$emit('confirm', e);
    },
  },
};
</script>
